import React from 'react';
import { NavLink } from "react-router-dom";
function SoapOperation() {

    return (
        <div className="operation-list">
            <div className="operation-name">
                <NavLink to="/soapui/probe" activeClassName="active">Probe</NavLink>
            </div>
            <div className="operation-name">
                <NavLink to="/soapui/tokenauth">Token Auth</NavLink>
            </div>
            <div className="operation-name">
                <NavLink to="/soapui/tokensettle">Token Settle</NavLink>
            </div>
            <div className="operation-name">
                <NavLink to="/soapui/tokenauthsettle">Token Auth & Settle</NavLink>
            </div>
            <div className="operation-name">
                <NavLink to="/soapui/tokenrefund">Token Refund</NavLink>
            </div>
            <div className="operation-name">
                <NavLink to="/soapui/voidauth">Void Auth</NavLink>
            </div>
        </div>
         
    );
}

export default SoapOperation;
